import React, { useState } from "react";
import Loading from "../../../components/loading";
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { FTextField } from "../../../components/form-elements";
import DialogTitle from "../../../components/dialog-title";
import lensesService from "../../../services/lenses.service";
import { useErrorHandler } from "../../../hooks";

const emptyValues = {
  name: "",
  description: "",
};
const formSchema = Yup.object().shape({
  name: yupSchema.name,
  description: yupSchema.description,
});
export default function FormModalContent({ close, data }) {
  const [waiting, setWaiting] = useState(false);
  const { id, ...initialValues } = data || {};
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model) => {
    setWaiting(true);
    let op;
    if (id) {
      op = await lensesService.editLens(id, model);
    } else {
      op = await lensesService.createLens(model);
    }
    const { data: savedLens, error } = op;
    setWaiting(false);
    if (error) {
      errorHandler(error);
      return;
    }
    close(savedLens || { ...model });
  };
  return (
    <Loading isLoading={waiting} overlay>
      <DialogTitle onClose={() => close()}>
        {id ? "ویرایش عدسی" : "ایجاد عدسی"}
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={id ? initialValues : emptyValues}
        onSubmit={handleSubmit}
        validationSchema={formSchema}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off">
            <DialogContent>
              <FTextField name="name" label="نام" autoFocus />
              <FTextField
                name="description"
                multiline
                rows={4}
                label="توضیحات"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={close} color="primary" disabled={isSubmitting}>
                لغو
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                variant="contained"
                color="primary"
              >
                {id ? "ذخیره" : "ایجاد"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Loading>
  );
}
